import { Component, h } from 'preact';
import { connect } from 'redux-zero/preact';

import actions from '../store/actions';
import Cookie from 'js-cookie';
import Crs from '../store/countries'

const langs = [
    { id: 'id', name: 'Bahasa Indonesia' },
    { id: 'br', name: 'Brazilian Portuguese' },
    { id: 'cn', name: '中文' },
    { id: 'cz', name: 'čeština' },
    { id: 'en', name: 'English' },
    { id: 'es', name: 'Español' },
    { id: 'fr', name: 'Français' },
    { id: 'it', name: 'Italiano' },
    { id: 'jp', name: '日本語 (にほんご)' },
    { id: 'kr', name: '한국어' },
    { id: 'kg', name: 'Kyrgyz' },
    { id: 'kz', name: 'қазақ тілі' },
    { id: 'hu', name: 'Magyar' },
    { id: 'tr', name: 'Turkish' },
    { id: 'ru', name: 'русский' },
    { id: 'si', name: 'Slovenčina' },
    { id: 'th', name: 'ไทย' },
    { id: 'vn', name: 'Vietnamese' },
]

const mapToProps = ({
    etest,
    isStart,
    email,
    token,
    type,
    debug,
    fullname,
    dial_code,
    phone_number,
    devMode,
    level,
    levels,
    isPrepare,
    email_confirmation,
    pre_test,
    geoip,
    attempt_of_test
}) => ({
    etest,
    isStart,
    email,
    token,
    type,
    debug,
    fullname,
    dial_code,
    phone_number,
    devMode,
    level,
    levels,
    isPrepare,
    email_confirmation,
    pre_test,
    geoip,
    attempt_of_test
});

import config from '../../config.json';
import pkg from '../../package.json';

import { $lang, allowFromHosts, setFormData, isComplete } from '../plugins/helper';

import FormMessage from '../components/Modal/FormMessage';
import Cookies from 'js-cookie';

class Form extends Component {
    constructor(props) {
        super(props);

        this.startQuestion = this.startQuestion.bind(this);
        this.props.handleChange = this.props.handleChange.bind(this);
        this.onTokenChange = this.onTokenChange.bind(this);
        this.props.handleDialCode = this.props.handleDialCode.bind(this);
        this.onTypeChange = this.onTypeChange.bind(this);
        this.validateEmail = this.validateEmail.bind(this);
        this.validateFullname = this.validateFullname.bind(this)
        this.changeLanguage = this.changeLanguage.bind(this);
        this.handleCountries = this.handleCountries.bind(this)

        this.state = {
            lang: 'en',
            isoCode: 'EN',
            emailValid: true,
            fullnameValid: true,
        }
    }

    async componentDidMount() {
        let isoCode = this.state.isoCode;

        if (typeof Cookie.get('etest_lang') !== 'undefined') {
            isoCode = Cookie.get('etest_lang');
        } else {
            for (let index in config.geoip) {
                await this.props.getIP(index);
                if (typeof this.props.geoip !== 'undefined') {
                    isoCode = this.props.geoip;
                    break;
                }
            }
        }
        Cookie.set('etest_lang', isoCode.toLowerCase());

        this.props.setLang(isoCode.toLowerCase());

        // Set isoCode lokal dulu
        this.setState({ isoCode: isoCode.toUpperCase(), lang: isoCode.toLowerCase() }, () => {
            // setelah setState lokal selesai, update dial_code di global store
            const country = Crs.find(c => c.country_iso.toLowerCase() === isoCode.toLowerCase());
            if (country) {
                this.props.handleChange({ target: { name: 'dial_code', value: country.dial_code } });
            }
        });
    }


    /**
        * on change set selected the dial code
        *
        * @param {Event} e
        * @return {void}
        */
    isSelectedDialCode(e) {
        this.state = {
            lang: e.target.value,
            isoCode: e.target.value.toUpperCase(),
            fullnameValid: this.props.fullname != ''
        }
        this.props.handleDialCode({
            target: { value: String(e.target.value).toUpperCase() }
        })
        this.validateEmail({ target: { value: this.props.email } })
        this.props.handleChange(e)
    }

    /**
     * Call question api in redux action to start question
     *
     * @param {Event} e
     * @return {void}
     */
    startQuestion(e) {
        e.preventDefault();

        const { type, devMode, token, fullname, email, dial_code, phone_number, level, pre_test, attempt_of_test } = this.props;

        this.props.loadQuestion('form', setFormData(
            email,
            token,
            type,
            fullname,
            dial_code,
            phone_number,
            (config.app_env == 'production') ? false : devMode == "true",
            (type == 'et' && level) ? level : "A1",
            pre_test,
            true,
        )
        ).then(() => {
            if (isComplete(this.props.etest.status) && type == 'pt' && this.props.etest.attempt == attempt_of_test) {
                this.props.submitQuestion();
            }
        })
    }

    /**
     * @return {string}
     */
    testType() {
        const { type } = this.props;

        if (type == 'et') {
            return 'Certification Test';
        }

        return 'Assessment Test';
    }

    /**
     * handle on refresh bedore start test
     * get from last candidate take etest
     * @param {*} key
     * @returns
     */
    handleOnRefershBeforeStartTest(key) {
        if (Cookies.get('etest_last')) {
            let student = JSON.parse(
                decodeURIComponent(
                    escape(atob(Cookies.get(`etest_last`)))
                )
            );
            if (key == 'email' || key == 'email_confirmation') {
                return student.email
            }
            if (key == 'token') {
                return student.token
            }
            if (key == 'fullname') {
                return student.fullname
            }
            if (key == 'dial_code') {
                return student.dial_code
            }
            if (key == 'phone_number') {
                return student.phone_number
            }
            if (key == 'pre_test') {
                return student.pre_test
            }
        }
    }

    onTokenChange(e) {
        if (this.props.type == 'et' || this.isDevelopmentMode()) {
            this.props.verifyToken({ token: e.target.value, ignoreValidation: true }).catch(() => { });
        }
        this.props.handleChange(e);
    }

    onTypeChange(e) {
        const { token } = this.props;

        if (token.length) {
            this.props.verifyToken({ token, ignoreValidation: true }).catch(() => { })
        }
        this.props.handleChange(e);
    }

    validateEmail(e) {
        const emailRegex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})/;
        this.state.emailValid = true
        if (!emailRegex.test(e.target.value)) {
            this.state.emailValid = false
        }
        if ((!(/^\S{3,}$/.test(e.target.value)))) {
            this.state.emailValid = false
        }
        this.props.handleChange(e);

    }

    validateFullname(e) {
        if (e.target.value.length > 50) {
            this.state.fullnameValid = false
        } else {
            this.state.fullnameValid = true
        }
        this.props.handleChange(e);
    }
    /**
     * Check if app is in development mode.
     * config.app_env must be development.
     * param debug can be true or false.
     *
     * @return {boolean}
     */
    isDevelopmentMode() {
        const { devMode } = this.props;

        return config.app_env == 'development' && devMode == 'true';
    }
    handleCountries(e) {
        const isoCode = e.target.value
        const country = Crs.find(c => c.country_iso.toLowerCase() === isoCode.toLowerCase());
        if (country) {
            this.setState({ isoCode: isoCode.toUpperCase() });
            this.props.handleChange({ target: { name: 'dial_code', value: country.dial_code } });
        }
    };

    /**
     *
     * @param {Event} e
     */
    changeLanguage(e) {
        Cookie.set('etest_lang', e.target.value);
        this.props.setLang(e.target.value);
        this.isSelectedDialCode(e)
        this.forceUpdate()
    }

    render({ token, isStart, type, email, fullname, levels, devMode, isPrepare, handlePrepare, email_confirmation, phone_number, pre_test, dial_code }) {
        if (this.handleOnRefershBeforeStartTest('pre_test')) {
            pre_test = this.handleOnRefershBeforeStartTest('pre_test')
            if (pre_test == 'true') {
                this.props.handleSetPreTest('true')
                this.props.handleSetEmail(this.handleOnRefershBeforeStartTest('email'))
                this.props.handleSetFullname(this.handleOnRefershBeforeStartTest('fullname'))
                this.props.handleSetDialCode(this.handleOnRefershBeforeStartTest('dial_code'))
                this.props.handleSetPhoneNumber(this.handleOnRefershBeforeStartTest('phone_number'))
            }
        }
        const iso = String(this.state.isoCode)
        const availableIds = langs.map(l => l.id);
        const selectedLang = availableIds.includes(iso.toLowerCase()) ? iso.toLowerCase() : 'en';

        return (
            <div className="et-container et-px-4 et-mx-auto">
                <div className="et-flex et-justify-center">
                    <div className="et-w-full md:et-w-1/2">
                        <div className="etest-form">
                            {isStart == false &&
                                <h2 className="et-text-4xl et-text-center et-text-primary et-font-bold notranslate">
                                    {this.testType()}
                                </h2>
                            }

                            <div className="et-flex et-justify-center et-mb-6 et-mt-4">
                                <div className="et-mb-5 et-relative et-w-48">
                                    <select name="language" className="e-form-control et-py-1 lang-option"
                                        value={selectedLang}
                                        onChange={this.changeLanguage}>
                                        {
                                            langs.map(lang => (
                                                <option key={lang.id} value={lang.id} >{lang.name} </option>
                                            ))
                                        }
                                    </select>

                                    <div class="et-pointer-events-none et-absolute et-inset-y-0 et-right-0 et-flex et-items-center et-px-2 et-text-gray-700">
                                        <svg class="et-fill-current et-h-4 et-w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                                    </div>
                                </div>
                            </div>
                            <div className={!allowFromHosts() ||
                                type == 'et' && !this.isDevelopmentMode() ||
                                type == 'pt' && pre_test == 'true' && !this.isDevelopmentMode() ? 'et-hidden' : ''}>
                                {this.isDevelopmentMode() &&
                                    <div className="et-mb-5 et-relative">
                                        <select name="type" onChange={this.onTypeChange} className="e-form-control">
                                            <option value="pt">Assessment Test</option>
                                            <option value="et">Certification Test</option>
                                        </select>
                                        <div class="et-pointer-events-none et-absolute et-inset-y-0 et-right-0 et-flex et-items-center et-px-2 et-text-gray-700">
                                            <svg class="et-fill-current et-h-4 et-w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                                        </div>
                                    </div>
                                }
                                <div className="et-mb-5">
                                    <input name="token" onChange={this.onTokenChange} value={token} id="inline-full-name" className={!this.isDevelopmentMode() ? 'et-hidden' : 'e-form-control'} placeholder="Token" />
                                </div>

                                <div className="et-mb-5">
                                    <input type="text" value={fullname} onChange={this.validateFullname} name="fullname" className="e-form-control" placeholder={$lang('input.name')} />
                                    {!fullname && type == 'pt' && <span className="et-ml-4 et-text-sm et-text-red-500">{$lang('input.fullname_required')}</span>}
                                    {fullname && type == 'pt' && !this.state.fullnameValid && <span className="et-ml-4 et-text-sm et-text-red-500">{$lang('input.fullname_limitation') || "The name can't be more than 50 characters"}</span>}
                                </div>

                                <div className="et-mb-5">
                                    <input name="email" type="email" onChange={this.validateEmail} className="e-form-control" value={email} placeholder={$lang('input.email')} />
                                    {!email && <span className="et-ml-4 et-text-sm et-text-red-500">{$lang('input.email_required')}</span>}
                                    {email && !this.state.emailValid && <span className="et-ml-4 et-text-sm et-text-red-500">{$lang('input.email_required')}</span>}
                                </div>

                                {
                                    allowFromHosts() &&
                                    <div className="et-mb-5">
                                        <input type="email" onPaste={(e) => e.preventDefault()} value={email_confirmation} onChange={this.props.handleChange} name="email_confirmation" id="emailConfirmation" className="e-form-control" placeholder={$lang('input.email_confirmation')} />
                                        {email.toLowerCase() != email_confirmation.toLowerCase() && <span className="et-ml-4 et-text-sm et-text-red-500">{$lang('validation.confirm', { attr: 'Email' })}</span>}
                                    </div>
                                }

                                <div className="et-mb-5 et-relative notranslate">
                                    <select
                                        name="dial_code"
                                        onChange={this.handleCountries}
                                        className="e-form-control"
                                        value={iso.toUpperCase() || 'EN'}
                                    >
                                        {Crs.map((country) => (
                                            <option value={country.country_iso} key={country.country_iso}>
                                                {country.dial_code} ({country.name})
                                            </option>
                                        ))}
                                    </select>

                                    <div class="et-pointer-events-none et-absolute et-inset-y-0 et-right-0 et-flex et-items-center et-px-2 et-text-gray-700">
                                        <svg class="et-fill-current et-h-4 et-w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                                    </div>
                                </div>

                                <div className="et-mb-5">
                                    <input type="number" inputmode="numeric" onChange={this.props.handleChange} name="phone_number" value={phone_number} className="e-form-control" placeholder={$lang('input.phone')} />
                                    {!phone_number && <span className="et-ml-4 et-text-sm et-text-red-500">{$lang('input.phone_required')}</span>}
                                </div>

                                {
                                    !!(type == 'et' && levels.length && devMode) &&
                                    <div className="et-mb-5 et-flex et-justify-between et-flex-wrap">
                                        {levels.map((level, i) => (
                                            <div className="neo-radio">
                                                <input type="radio" onChange={this.props.handleChange} name="level" value={level} id={level} />
                                                <label htmlFor={level}>
                                                    <span>
                                                        {level}
                                                    </span>
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                }
                            </div>


                            <div className="et-mb-5 et-mt-10 et-text-center notranslate">
                                <button onClick={() => handlePrepare(this.state.emailValid && this.state.fullnameValid)} class="neo-btn neo-btn--primary et-rounded-full et-px-10 et-py-3">
                                    {$lang('button.start_test')}
                                </button>
                            </div>

                            <span className="et-block et-text-center et-text-gray-500 et-uppercase et-text-sm et-mb-2 notranslate">powered by</span>
                            <div className="et-flex et-flex-col et-text-center">
                                <div className="et-flex-1 et-flex et-justify-center">
                                    <img id="neologoimage" src="https://neo.dyned.com.cn/assets/img/logo_neo.svg" className="et-w-20" />
                                </div>

                                <span className="et-flex-1 et-mt-2 et-text-gray-700 et-text-sm notranslate">v{pkg.version}</span>
                                <span className="et-flex-1 et-mt-2 et-text-gray-700 et-text-sm notranslate">{config.icp_version}</span>
                            </div>
                            {isPrepare && <FormMessage startQuestion={this.startQuestion} />}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(mapToProps, actions)(Form)